module.exports = __webpack_public_path__ + "static/media/france_flag.0dd1a1ce.svg";